<!--
    描述：面包屑导航
    时间：2020-04-15
    Created by ws
-->
<template>
	<div class="w-breadcrumb-container">
		<!-- 左侧收缩按钮 -->
		<div class="w-collapse-btn"
			 @click="handleCollapse">
			<el-tooltip :content="collapseText"
						placement="bottom-start"
						:open-delay="500">
				<svg-icon icon-class="dashboard"></svg-icon>
			</el-tooltip>
		</div>

		<!-- 面包屑 -->
		<el-breadcrumb separator-class="el-icon-arrow-right"
					   class="w-breadcrumb">
			<transition-group name="breadcrumb">
				<el-breadcrumb-item v-for="(item, index) in breadList"
									:key="item.path"
									:to="item.path">{{ item.meta.title }}</el-breadcrumb-item>
			</transition-group>
		</el-breadcrumb>

		<!-- 个人信息 -->
		<right-info v-if="!showHeader"></right-info>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import rightInfo from './rightInfo'

export default {
	components: {
		rightInfo
	},
	data() {
		return {
			breadList: null,
		}
	},
	methods: {
		...mapActions('app', ['setCollapse']),

		// 点击 是否折叠左侧菜单
		handleCollapse() {
			let value = !this.isCollapse
			this.setCollapse(value)
		},
		// 获取面包屑数组
		getBreadcrumb() {
			// console.log(this.$route)
			// only show routes with meta.title
			let matched = this.$route.matched.filter(
				item => item.meta && item.meta.title
			)
			const first = matched[0]

			if (!this.isMain(first)) {
				matched = [{ path: '/main', meta: { title: '首页' } }].concat(
					matched
				)
			}

			this.breadList = matched.filter(
				item =>
					item.meta &&
					item.meta.title &&
					item.meta.breadcrumb !== false
			)
		},

		// 判断是否是首页
		isMain(route) {
			const name = route && route.name
			if (!name) {
				return false
			}
			return (
				name.trim().toLocaleLowerCase() === 'Main'.toLocaleLowerCase()
			)
		},

	},
	created() {
		// 初始渲染面包屑
		this.getBreadcrumb()
	},
	computed: {
		...mapState('app', {
			isCollapse: state => state.isCollapse
		}),
		...mapState('settings', {
			showHeader: state => state.showHeader
		}),
		// 图标提示语
		collapseText() {
			return this.isCollapse ? '点击展开左侧' : '点击收起左侧'
		}
	},
	watch: {
		// 监听路由变化 更新面包屑
		$route(val) {
			this.getBreadcrumb()
		}
	}
}
</script>

<style lang="less">
.w-breadcrumb-container {
	width: 100%;
	height: 100%;
	display: flex;

	.w-collapse-btn {
		padding: 0 10px;
		cursor: pointer;
	}

	.w-breadcrumb {
		line-height: 35px;
		flex: 1;

		&:before {
			float: left;
			content: '';
			width: 0;
			height: 29px;
			margin-top: 3px;
			background-color: #008080;
		}
	}

	.el-breadcrumb__inner {
		cursor: pointer !important;
		font-weight: 700 !important;
	}
}
</style>
